import { ForwardedRef, forwardRef } from "react";
import { Select } from "antd";
import { HiOutlineChevronDown } from "react-icons/hi2";
import { ValidationError } from "../validation-error";
import "./select.scss";

const baseClassName = "form-select";

interface IFormSelectProps {
  className?: string;
  defaultValue?: string | string[];
  value?: string | string[] | null;
  label?: string;
  options: any[];
  disabled?: boolean;
  allowClear?: boolean;
  loading?: boolean;
  placeholder?: string;
  mode?: "multiple" | "tags";
  onChange: (value: string | string[]) => void;
  error?: string;
  note?: string;
}

const baseClass = "field-select";

export const FormSelect = forwardRef(
  (
    {
      className = "",
      options,
      defaultValue = "",
      value = "",
      label = "",
      loading = false,
      disabled = false,
      allowClear = false,
      error = "",
      placeholder = "",
      mode,
      note = "",
      onChange,
    }: IFormSelectProps,
    ref: ForwardedRef<any>
  ): JSX.Element => {
    return (
      <div className={baseClass}>
        {label && <label className={`${baseClass}__label`}>{label}</label>}
        <Select
          ref={ref}
          defaultValue={defaultValue}
          value={value}
          className={`${baseClassName} ${className}`}
          onChange={onChange}
          options={options}
          loading={loading}
          allowClear={allowClear}
          placeholder={placeholder}
          status={error ? "error" : undefined}
          disabled={disabled}
          mode={mode}
          suffixIcon={<HiOutlineChevronDown size={16} />}
        />
        {note && <p className={`${baseClass}__note`}>{note}</p>}
        {error && <ValidationError>{error}</ValidationError>}
      </div>
    );
  }
);
